export const branchesNamesToString = branches =>
  (branches && branches.length > 0 && branches.map(b => b.name).join(", ")) || "-";
